var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIneditos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.828 9.795l-2.865.61 1.94 2.19-1.696 1.257-1.51-2.533-1.508 2.533-1.728-1.256 1.912-2.13-2.866-.67.647-2.011 2.652 1.149L4.59 6.01h2.151l-.338 2.872 2.747-1.131.677 2.043zM11.222 20V0H.112v20l5.554-5.556L11.222 20z",
    fill: "#FFA435"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAyMCIgZmlsbD0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik05LjgyODA4IDkuNzk1MzZMNi45NjI4OSAxMC40MDQzTDguOTAyNTIgMTIuNTk1N0w3LjIwNjYyIDEzLjg1MjJMNS42OTc4NiAxMS4zMTlMNC4xODkxMSAxMy44NTIyTDIuNDYxMjkgMTIuNTk1N0w0LjM3MzM1IDEwLjQ2NkwxLjUwNjcxIDkuNzk1MzZMMi4xNTM3NCA3Ljc4NDg4TDQuODA1NjYgOC45MzM3M0w0LjU5MDk2IDYuMDExMzRINi43NDIzOEw2LjQwNDM2IDguODgzNDZMOS4xNTA1OSA3Ljc1MTg1TDkuODI4MDggOS43OTUzNlpNMTEuMjIyMiAyMFYwSDAuMTExMTE1VjIwTDUuNjY1OTUgMTQuNDQzOUwxMS4yMjIyIDIwWiIgZmlsbD0iI0ZGQTQzNSIvPgo8L3N2Zz4K";
export { SvgIconIneditos as ReactComponent };